// Valida el capital maximo a financiar obteniendo el menor entre el capital maximo a financiar de la linea
// y el porcentaje maximo de financiacion multiplicado por el precio finaciable del vehiculo.
export const validateCapMaxFinanciacion = (
    lineasFinancieras,
    selectedLineaFinanciera,
    cuotasAfinanciar
) => {
    const lineaSeleccionada = lineasFinancieras.find(
        ({ id }) => id === Number(selectedLineaFinanciera)
      )
      // Al seleccionar la linea por primera vez se setea cuotasAfinanciar con la menor cantidad 
      // de cuotas que ofrece la linea
    
    if(!cuotasAfinanciar && selectedLineaFinanciera && lineaSeleccionada) {
          cuotasAfinanciar = Math.min(...lineaSeleccionada.lines.map(({ quantity }) => quantity)) 
    }

    const linea = lineaSeleccionada?.lines.find(lineaFind => lineaFind.quantity === Number(cuotasAfinanciar))
    const maxCap = linea?.capMax
    const exceedFinanceLimit = lineaSeleccionada?.exceedFinanceLimit
    const lineExists = !!linea
    return {maxCap, cuotasAfinanciar, exceedFinanceLimit, lineExists}
}
